"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextLink = _interopRequireDefault(require("./../../TextLink"));
var ErrorPageAction = function ErrorPageAction(_ref) {
  var action = _ref.action,
    text = _ref.text;
  var actionLink = /*#__PURE__*/_react.default.createElement(_TextLink.default, null, text);
  if (action && typeof action === 'string') {
    actionLink = /*#__PURE__*/_react.default.createElement(_TextLink.default, {
      href: action
    }, text);
  } else if (action && typeof action === 'object') {
    actionLink = action;
  }
  return actionLink;
};
var _default = exports.default = ErrorPageAction;